/* Tecán theme behaviors: age gate, sticky ATC, newsletter 18+ consent.
   Vanilla, deferred, no dependencies. */
(function () {
  'use strict';

  var AGE_KEY = 'tecan_age_ok';
  var AGE_TTL = 30 * 24 * 60 * 60 * 1000; /* 30 days */

  function ageVerified() {
    try {
      var raw = window.localStorage.getItem(AGE_KEY);
      if (!raw) return false;
      var ts = parseInt(raw, 10);
      if (isNaN(ts) || Date.now() - ts > AGE_TTL) {
        window.localStorage.removeItem(AGE_KEY);
        return false;
      }
      return true;
    } catch (e) {
      /* Storage unavailable: fail open so the shop stays browsable;
         transactional age checks happen at checkout and delivery. */
      return true;
    }
  }

  function initAgeGate() {
    var gate = document.getElementById('TecanAgeGate');
    if (!gate) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (ageVerified()) return;

    var doc = document.documentElement;
    gate.classList.add('is-open');
    doc.classList.add('tecan-age-locked');

    var focusables = gate.querySelectorAll('button, a[href]');
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    var previouslyFocused = document.activeElement;

    function trap(event) {
      if (event.key !== 'Tab') {
        /* Escape must not dismiss: entry requires an explicit choice. */
        return;
      }
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    gate.addEventListener('keydown', trap);
    if (first) first.focus();

    var enter = gate.querySelector('[data-age-gate-enter]');
    if (enter) {
      enter.addEventListener('click', function () {
        try {
          window.localStorage.setItem(AGE_KEY, String(Date.now()));
          if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
            window.Shopify.analytics.publish('age_gate_passed');
          }
        } catch (e) {
          /* noop */
        }
        gate.classList.remove('is-open');
        doc.classList.remove('tecan-age-locked');
        gate.removeEventListener('keydown', trap);
        if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
      });
    }
  }

  function initStickyAtc() {
    var bar = document.querySelector('.tecan-sticky-atc');
    if (!bar) return;
    var anchor = document.querySelector('.product-form__submit');
    if (!anchor || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', passed);
          bar.toggleAttribute('aria-hidden', !passed);
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchor);
  }

  function initNewsletterConsent() {
    document.querySelectorAll('form.newsletter-form').forEach(function (form) {
      var checkbox = form.querySelector('[data-tecan-age-consent]');
      if (!checkbox) return;
      form.addEventListener('submit', function (event) {
        if (!checkbox.checked) {
          event.preventDefault();
          form.classList.add('tecan-consent-missing');
          checkbox.focus();
          return;
        }
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish('newsletter_signup_18plus');
        }
      });
      checkbox.addEventListener('change', function () {
        if (checkbox.checked) form.classList.remove('tecan-consent-missing');
      });
    });
  }

  function initFilmHero() {
    var hero = document.querySelector('.tecan-hero');
    if (!hero) return;
    var headerWrap = document.querySelector('.section-header .header-wrapper');
    if (headerWrap) {
      var onScroll = function () {
        headerWrap.classList.toggle('tecan-header-solid', window.scrollY > 40);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var video = hero.querySelector('.tecan-hero__video');
    if (video && window.matchMedia('(min-width: 750px)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.preload = 'auto';
      video.addEventListener('playing', function () { video.classList.add('is-playing'); });
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* poster stays; autoplay blocked is fine */ });
    }
  }

  function init() {
    initFilmHero();
    initAgeGate();
    initStickyAtc();
    initNewsletterConsent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
